var _path, _path2, _path3, _path4, _path5;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFileText(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 136,
    height: 136,
    viewBox: "0 0 136 136",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M79.3333 11.3333H34C30.9942 11.3333 28.1115 12.5274 25.9861 14.6528C23.8607 16.7782 22.6667 19.6609 22.6667 22.6666V113.333C22.6667 116.339 23.8607 119.222 25.9861 121.347C28.1115 123.473 30.9942 124.667 34 124.667H102C105.006 124.667 107.888 123.473 110.014 121.347C112.139 119.222 113.333 116.339 113.333 113.333V45.3333L79.3333 11.3333Z",
    stroke: "#BEAAF3",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M79.3333 11.3333V45.3333H113.333",
    stroke: "#BEAAF3",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M90.6667 73.6667H45.3333",
    stroke: "#BEAAF3",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M90.6667 96.3333H45.3333",
    stroke: "#BEAAF3",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M56.6667 51H51H45.3333",
    stroke: "#BEAAF3",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFileText);
export default __webpack_public_path__ + "static/media/file-text.8f3f4e42f44fce502b0b07074309dd7e.svg";
export { ForwardRef as ReactComponent };